import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as twilio from 'twilio-video';
import { throttle } from 'lodash';
import TerapiLogo from '../../images/desktop_new_logo.svg';
import HangUpIcon from '../../images/hang-up-small.png';
import Modal from 'react-modal';
import Moment from "react-moment";
import { isMobile } from './browser';

class VideoConference extends Component {
  constructor(props) {
    super(props);
    this.remote_part = this.getRemotePart();
    this.room = null;
    this.localParticipant = null;
    this.state = {
      video_accepted: null,
      remote_connected: false,
      small_video_participant: this.remote_part.name,
      preferences_modal_is_open: false,
      local_height: false,
      local_width: false,
      audio_muted: false,
      sharing_screen: false,
    };
    this.hangup = this.hangup.bind(this);
    this.muteMicrophone = this.muteMicrophone.bind(this);
    this.toggleChat = this.toggleChat.bind(this);
    this.shareScreen = this.shareScreen.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.removeRemoteParticipant = this.removeRemoteParticipant.bind(this);
    this.updateDeviceList = this.updateDeviceList.bind(this);
    this.changeCamera = this.changeCamera.bind(this);
    this.isAbleToShareScreen = this.isAbleToShareScreen.bind(this);
    this.stopShareScreen = this.stopShareScreen.bind(this);
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.devices_list = [];
    this.current_device = '';
    this.shareScreenTrack = null;
    this.remoteScreenShareTrack = null;

    // to react on resize events, we used here a throttled version to avoid performance issues
    this.onScreenResize = throttle(this.onScreenResize.bind(this), 300);
  }

  updateDeviceList(mediaDevices){
    mediaDevices.forEach(mediaDevice =>{
      if(mediaDevice.kind == 'videoinput'){
        this.devices_list.push(mediaDevice.deviceId)
      }
    })
  }

  componentDidMount() {
    this.connectToRoom();
    window.addEventListener("resize", this.onScreenResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onScreenResize);
  }

  onScreenResize = () => {
    if (this.shareScreenTrack != null || this.remoteScreenShareTrack != null) {
      // we will resize the screen share if we have a screenshare on site
      const dimensions = this.shareScreenTrack != null ? this.shareScreenTrack.dimensions : this.remoteScreenShareTrack.dimensions;
      const screenVideo = document.getElementById('screen-media');
      const screenShareDimensions = this.calculateShareScreenConstraints(dimensions);
      console.log("[onScreenResize] calculated screen dimensions: ", screenShareDimensions);
      screenVideo.style.width = `${screenShareDimensions.width}px`;
      screenVideo.style.height = `${screenShareDimensions.height}px`;
    }
  }

  getRemotePart() {
    if (this.props.holder.type === this.props.appointment.patient.type) {
      return this.props.appointment.professional;
    }
    return this.props.appointment.patient;
  }

  connectToRoom() {
    const self = this;
    twilio.connect(this.props.holderToken, {
      name: this.props.roomToken,
      audio: true,
      //maxAudioBitrate: 16000,
      video: { width: 640, height: 480, frameRate: {ideal: 10, max: 30}, facingMode: 'user'},
    }).then(room => {
      const localParticipant = room.localParticipant;
      self.localParticipant = room.localParticipant;
      const bigVideo = document.getElementById('local-media');
      const smallVideo = document.getElementById('remote-media');

      navigator.mediaDevices.enumerateDevices().then(this.updateDeviceList);

      self.room = room;

      console.log(`Successfully joined a Room: ${room}`);
      console.log(`Connected to the Room as LocalParticipant "${localParticipant.identity}"`);
      console.log(room, room.participants, room.participants.size);

      // first, we check the number of participants
      self.setState({ video_accepted: true });

      if (room.participants.size > 0) {
        // we need to display videos in the right position, the remote on the main video and the local on the small
        room.participants.forEach(participant => {
          console.log(`Participant "${participant.identity}" is connected to the Room`);
          this.addRemoteParticipant(localParticipant, participant, bigVideo, smallVideo);
        });
      } else {
        // in this case, we are the only user on the call, so we display in the main video our camera
        console.log("in this case, we are the only user on the call, so we display in the main video our camera");
        this.removeRemoteParticipant(localParticipant, bigVideo, smallVideo);
      }

      room.on('participantConnected', participant => {
        console.log(`A remote Participant connected: ${participant}`);
        this.addRemoteParticipant(localParticipant, participant, bigVideo, smallVideo);
      });

      room.on('trackPublished', (publication, participant) => {
        console.log(publication, participant);
      });

      /*room.on('trackPublished', (publication, participant) => {
        console.log('trackPublished');
        if (publication.kind == "video"){
          const track = publication.track
          if ( track ){
            console.log(track);
            const bigVideo = document.getElementById('local-media');
            let dimensions = track.dimensions;
            console.log(track.dimensions);
            if (dimensions["height"] > dimensions["width"]){
              console.log('Mobile dimensions')
              bigVideo.getElementsByTagName("video")[0].style.height = `${innerHeight}px`;
            }else{
              let correction = ((dimensions["height"] * innerWidth) / dimensions["width"]) - innerHeight;
              if (correction > 0){
                bigVideo.getElementsByTagName("video")[0].style.width = `calc(100% - ${correction}px)`
              }
            }
          }
        }       
      });*/

      room.once('participantDisconnected', participant => {
        console.log(`Participant "${participant.identity}" has disconnected from the Room`);
        this.removeRemoteParticipant(localParticipant, bigVideo, smallVideo);
      });

      room.on('disconnected', room => {
        // Detach the local media elements
        room.localParticipant.tracks.forEach(publication => {
          const attachedElements = publication.track.detach();
          attachedElements.forEach(element => element.remove());
        });
      });
    }, error => {
      console.log(`Unable to connect to Room: ${error.message}`);
      self.setState({ video_accepted: false });
    });
  }

  trackPublished(localTrackPublication) {
    console.log('Succesfully published track %s  with name %s to room "%s"', localTrackPublication.trackSid, localTrackPublication.trackName, roomName);
  }

  addRemoteParticipant(localParticipant, remoteParticipant, bigVideo, smallVideo) {
    this.setState({ remote_connected: true, small_video_participant: "Tú" });

    const self = this;

    bigVideo.classList.remove("local-media-with-share-on-disconnect");

    // remote on the big screen
    while (bigVideo.firstChild) {
      bigVideo.removeChild(bigVideo.firstChild);
    }
    // now, local video on the small track
    while (smallVideo.firstChild) {
      smallVideo.removeChild(smallVideo.firstChild);
    }
    localParticipant.tracks.forEach(publication => {
      const track = publication.track;
      if (track.kind == "audio"){
        smallVideo.appendChild(track.attach());
      } else {
        if (track.name != "screenshare") {
          console.log("[addRemoteParticipant] Attaching track to small video", track);
          let video_track = track.attach();
          video_track.setAttribute('muted', 'muted');
          video_track.style.transform = `scale(-1,1)`;
          smallVideo.appendChild(video_track);      
        }
      }
    });
    // attach tracks
    remoteParticipant.tracks.forEach(publication => {
      if (publication.isSubscribed) {
        const track = publication.track;
        bigVideo.appendChild(track.attach());
        if (track.kind == "video"){
            track.once('started', () => {
                const bigVideo = document.getElementById('local-media');
                let dimensions = track.dimensions;
                console.log(track.dimensions);
                if (dimensions["height"] > dimensions["width"]){
                  console.log('Mobile dimensions')
                  bigVideo.getElementsByTagName("video")[0].style.height = `${innerHeight}px`;
                }else{
                  let correction = ((dimensions["height"] * innerWidth) / dimensions["width"]) - innerHeight;
                  if (correction > 0){
                    bigVideo.getElementsByTagName("video")[0].style.width = `calc(100% - ${correction}px)`
                  }
                }
            });
          }
        }
    });

    remoteParticipant.on('trackUnsubscribed', track => {
      console.log("[trackUnsubscribed] A track has been unsubscribed: ", track);
      if (track.kind == "video" && track.name != "screenshare") {
        if (bigVideo.getElementsByTagName("video").length ){ 
          bigVideo.removeChild(bigVideo.getElementsByTagName("video")[0]);
        }
      } else if (track.name == "screenshare") {
        // it's a screenshare track, so we need to remove the elements from the layout of screenshare
        track.detach().forEach(function(el) {
          el.remove(); // remove the attached elements
        });
        const screenVideo = document.getElementById('screen-media');
        screenVideo.style.display = "none";

        // now we reposition the main video on the screen
        const mainVideo = document.getElementById('local-media');
        mainVideo.classList.remove("local-media-with-share");

        self.remoteScreenShareTrack = null;
      }
    });

    remoteParticipant.on('trackSubscribed', track => {
      console.log('trackSubscribed', track);
      if (track.kind == "video" && track.name != "screenshare") {
        let video_track = track.attach();
        video_track.setAttribute('muted', 'muted');
        bigVideo.appendChild(video_track);
        track.once('started', () => {
            const bigVideo = document.getElementById('local-media');
            let dimensions = track.dimensions;
            console.log(track.dimensions);
            if (dimensions["height"] > dimensions["width"]){
              console.log('Mobile dimensions')
              bigVideo.getElementsByTagName("video")[0].style.height = `${innerHeight}px`;
            }else{
              let correction = ((dimensions["height"] * innerWidth) / dimensions["width"]) - innerHeight;
              console.log(correction);
              if (correction > 0){
                bigVideo.getElementsByTagName("video")[0].style.width = `calc(100% - ${correction}px)`
              }
            }
        });
        //this.setState({height: dimensions["local_height"], local_width: dimensions["local_width"] })
        // width will be resized to 100% (innerWidth), and with that height will be resized too,
        // and might end up being bigger than the screen, to fix that we correct by the difference
        // between innerHeight and the new height
      } else if (track.name == "screenshare") {
        console.log('Screensharing started');
        let screenTrack = track.attach();
        const screenVideo = document.getElementById('screen-media');
        self.remoteScreenShareTrack = track;
        
        // before appending the element, we need to calculate the size constraints for the screen element
        const screenShareDimensions = this.calculateShareScreenConstraints(track.dimensions);
        console.log("[trackSubscribed] calculated screen dimensions: ", screenShareDimensions);
        screenVideo.style.width = `${screenShareDimensions.width}px`;
        screenVideo.style.height = `${screenShareDimensions.height}px`;
        screenVideo.style.display = "block";
        screenVideo.appendChild(screenTrack);

        // now we reposition the main video on the screen
        const mainVideo = document.getElementById('local-media');
        mainVideo.classList.add("local-media-with-share");
      } else {
        bigVideo.appendChild(track.attach());
      }
    });
  }

  hangup() {
    if (this.room) {
      console.log("[hangup] Disconnecting from room...");
      this.room.disconnect();
    }
    this.props.onHangUp();
  }

  changeCamera(){
      if (this.devices_list.length == 1){
        return
      }
      if (this.current_device === ''){
        this.current_device = this.localParticipant.videoTracks.values().next().value.track.mediaStreamTrack.getSettings().deviceId
      }
      const self = this
      let divVideo = '';
      if (self.room.participants.size < 1){
        divVideo = document.getElementById('local-media');
      } else {
        divVideo = document.getElementById('remote-media');
      }
      console.log(self.room.participants.size);
      this.localParticipant.tracks.forEach(publication => {
      const track = publication.track;
      if (track.kind == "video"){
        let current_idx = 0
        this.devices_list.forEach((id, idx) => {
          if (id == this.current_device){
            current_idx = idx;
          };
        });
        let current = this.devices_list[(current_idx + 1) % this.devices_list.length];
        this.current_device = current
      }
    }); 
    //const current_device = this.current_device;
    //const localParticipant = this.localParticipant;
    //const tracks = Array.from(localParticipant.videoTracks.values())
    //      .map(trackPublication => trackPublication.track);
    //tracks.forEach(track => track.stop()); 
    //localParticipant.videoTracks.forEach(async (publication) => {
    //    let localTrack = publication.track;
    //    localTrack = await localTrack.restart({deviceId: {exact: current_device}})
    //    .then(function(){
    //      return localTrack
    //    });
    //    bigVideo.appendChild(localTrack.attach());
    //  }
    //);

    //const tracks = Array.from(this.localParticipant.videoTracks.values())
    //      .map(trackPublication => trackPublication.track);
    //tracks.forEach(track => track.stop());     
    //navigator.mediaDevices
    //.getUserMedia({video: {
    //  deviceId: { exact: this.current_device}}, audio: false})
    //.then(stream => {
    //  bigVideo.getElementsByTagName("video")[0].srcObject = stream;
    //}).catch(error=>{
    //  alert(error);
    //}); 

    //track.restart({ deviceId: current });
    const tracks = Array.from(this.localParticipant.videoTracks.values())
          .map(trackPublication => trackPublication.track);
    tracks.forEach(track => track.stop()); 
    twilio.createLocalVideoTrack({
      dimensions: {width: 640, height: 480},
      deviceId: { exact: this.current_device},
    }).then(async localVideoTrack => {
      if (self.localParticipant) {
        let localParticipant = self.localParticipant;
        localParticipant.unpublishTracks(tracks);
        tracks.forEach(track => track.detach().forEach(element => element.remove()));
        await localParticipant.publishTrack(localVideoTrack);
        let video_track = localVideoTrack.attach();
        video_track.setAttribute('muted', 'muted');
        video_track.style.transform = `scale(-1,1)`;
        divVideo.appendChild(video_track);
       }
    }).catch(error=>{
      alert(error);
    });    
  }

  muteMicrophone() {
    if (!this.state.audio_muted) {
      this.localParticipant.audioTracks.forEach(audioTrack => audioTrack.track.disable());
    } else {
      this.localParticipant.audioTracks.forEach(audioTrack => audioTrack.track.enable());
    }
    this.setState({ audio_muted: !this.state.audio_muted });
  }

  isAbleToShareScreen() {
    const canUseNavigatorAPI = navigator && navigator.mediaDevices && "getDisplayMedia" in navigator.mediaDevices;
    const isSafariBrowser = (() => {
      const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
      const isSafari = navigator.userAgent.indexOf("Safari") > -1;
    
      if (isSafari){
        if (isChrome)  // Chrome seems to have both Chrome and Safari userAgents
          return false;
        return true;
      }
      return false;
    })();
    return this.props.holder.type == "psychologist" && !isMobile && !isSafariBrowser && canUseNavigatorAPI;
  }

  shareScreen() {
    if (this.isAbleToShareScreen()) {
      if (!this.state.sharing_screen) {
        const self = this;
        navigator.mediaDevices.getDisplayMedia().then((stream) => {
          self.shareScreenTrack = new twilio.LocalVideoTrack(stream.getTracks()[0], { name: "screenshare" });
          self.localParticipant.publishTrack(self.shareScreenTrack);
          console.log("[shareScreen] shareScreenTrack is ", self.shareScreenTrack);
          let video_track = self.shareScreenTrack.attach();
          console.log("[shareScreen] videoTrack is ", video_track);
          let screenVideo = document.getElementById('screen-media');

          // we set the onended event to disable the screen share when the user press the native disable share
          self.shareScreenTrack.mediaStreamTrack.onended = () => { self.stopShareScreen() };

          // before appending the element, we need to calculate the size constraints for the screen element
          const screenShareDimensions = this.calculateShareScreenConstraints(self.shareScreenTrack.dimensions);
          console.log("[shareScreen] calculated screen dimensions: ", screenShareDimensions);
          screenVideo.style.width = `${screenShareDimensions.width}px`;
          screenVideo.style.height = `${screenShareDimensions.height}px`;
          screenVideo.style.display = "block";
          screenVideo.appendChild(video_track);

          // now we reposition the main video on the screen
          const mainVideo = document.getElementById('local-media');
          mainVideo.classList.add("local-media-with-share");

          // set the state
          self.setState({ sharing_screen: true });
        }).catch((e) => {
          console.log("[shareScreen]", e);
          alert("Ha ocurrido un error al compartir su pantalla. Por favor, intente nuevamente.");
        });
      } else {
        this.stopShareScreen();
      }
    }
  }

  stopShareScreen() {
    if (this.state.sharing_screen) {
      // we unpublish the screen track
      this.localParticipant.unpublishTrack(this.shareScreenTrack);
      this.shareScreenTrack.stop();
      this.shareScreenTrack = null;

      //we remove the childs of screenVideo and set the display to none
      let screenVideo = document.getElementById('screen-media');
      screenVideo.style.display = "none";
      screenVideo.innerHTML = "";

      // now we reposition the main video on the screen
      const mainVideo = document.getElementById('local-media');
      mainVideo.classList.remove("local-media-with-share");
      mainVideo.classList.remove("local-media-with-share-on-disconnect");

      console.log("[stopShareScreen] setting sharing_screen state to false. Current val is ", this.state.sharing_screen);
      this.setState({ sharing_screen: false });
    }
  }

  calculateShareScreenConstraints(shareScreenTrack) {
    if (shareScreenTrack.dimensions) {
      const minHeight = window.innerHeight >= shareScreenTrack.dimensions.height ?  shareScreenTrack.dimensions.height : window.innerHeight;
      const minWidth = window.innerWidth >= shareScreenTrack.dimensions.width ?  shareScreenTrack.dimensions.width : window.innerWidth;

      return { 
        width: (minWidth * shareScreenTrack.height) / minHeight, 
        height: minHeight,
      }; 
    } else {
      return {
        width: window.innerWidth, 
        height: window.innerHeight,
      }
    }
  }

  showHelp(){
    $('#exampleModal').modal('show');
  }

  toggleChat() {
    let chatContainer = document.querySelector(".chat-room__videoconference");
    if (chatContainer.classList.contains("d-none")) {
      chatContainer.classList.remove("d-none");
      document.body.style.overflow = "hidden";
      document.getElementById('messagesBottom').scrollIntoView();
    } else {
      chatContainer.classList.add("d-none");
      document.body.style.overflow = "visible";
    }
  }

  removeRemoteParticipant(localParticipant, bigVideo, smallVideo) {
    console.log("[removeRemoteParticipant] Removing participant...");
    this.setState({ remote_connected: false, small_video_participant: this.remote_part.name });
    while (bigVideo.firstChild) {
      bigVideo.removeChild(bigVideo.firstChild);
    }
    localParticipant.tracks.forEach(publication => {
      console.log("publication", publication);
      const track = publication.track;
      console.log("track", track);

      if (track.name != "screenshare") {
        if (track.kind == "video"){
          let video_track = track.attach();
          video_track.setAttribute('muted', 'muted');
          video_track.style.transform = `scale(-1,1)`;

          bigVideo.appendChild(video_track);

          let dimensions = track.dimensions;
          //this.setState({height: dimensions["local_height"], local_width: dimensions["local_width"] })
          // width will be resized to 100% (innerWidth), and with that height will be resized too,
          // and might end up being bigger than the screen, to fix that we correct by the difference
          // between innerHeight and the new height
          if (dimensions["height"] > dimensions["width"]){
            console.log('Mobile dimensions')
            bigVideo.getElementsByTagName("video")[0].style.height = `${innerHeight}px`
          } else{
            let correction = ((dimensions["height"] * innerWidth) / dimensions["width"]) - innerHeight;
            console.log(track.dimensions);
            if (correction > 0){
              bigVideo.getElementsByTagName("video")[0].style.width = `calc(100% - ${correction}px)`
            }
          }
        } else {
          bigVideo.appendChild(track.attach());
        }
      } else {
        // for the screenshare case, we adapt the local media position
        const el = document.querySelector(".local-media-with-share");
        el.classList.add("local-media-with-share-on-disconnect");
      }
    });
    // we remove tracks from the small video
    while (smallVideo.firstChild) {
      smallVideo.removeChild(smallVideo.firstChild);
    }
  }

  openModal() {
    this.setState({ preferences_modal_is_open: true });
  }

  closeModal() {
    this.setState({ preferences_modal_is_open: false });
  }

  render() {
    const backgroundContainerStyle = {
      backgroundColor: "#000",
      height: "100%",
      position: "fixed",
      right: "0",
      bottom: "0",
      minWidth: "100%",
      minHeight: "100%",
    };
    const mainContainerStyle = {
      height: "100%",
      color: "#626262",
      position: "fixed",
      right: "0",
      bottom: "0",
      minWidth: "100%",
      minHeight: "100%",
    };

    const toolsContainerInfo = {
      marginTop: "15px",
    };

    const rowWithoutGutters = {
      marginRight: "0",
      marginLeft: "0",
      textAlign: "center",
    };

    const videoRemoteContainer = {
      width: "128px",
      height: "128px",
      position: "absolute",
      right: "0",
      margin: "15px",
    };

    const preferencesModalStyles = {
      overlay : {
        backgroundColor       : 'rgba(0, 0, 0, 0.5)'
      },
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
      }
    };

    const remoteFigure = {
      width: "70px",
      height: "70px",
      borderRadius: "50%",
      overflow: "hidden",
    };

    const remoteImage = {
      width: "70px",
      height: "auto",
    };

    const logoImage = {
      position: "absolute",
      marginTop: "20px",
      marginLeft: "20px",
      zIndex: "1",
    };

    return (
        <div className="rooms__videoconference-room">
          <div style={ backgroundContainerStyle }>
            <div id="local-media" />
            <div id="screen-media" />
            <div id="remote-media" className="d-md-block" style={ videoRemoteContainer }/>

            <div className="list_general" style={ mainContainerStyle }>
              <img height="22" src={ TerapiLogo } style={ logoImage } />
              { (this.state.video_accepted === false) &&
              <p className="rooms__videoconference-room-empty-message">
                Al parecer no aceptaste la cámara y micrófono. Por favor recarga la página
                y acepta la camara y micrófono cuando se te pregunte. Si no se te preguntó,
                revisa la configuración de la cámara en tu navegador y desbloqueala para esta página.
                Si no te funciona nada de lo anterior, revisa nuestro <a href="/terms" target="_blank">FAQ</a> o comunícate a contacto@terapi-app.com
              </p>
              }
              { (!(this.state.video_accepted === false) && !this.state.remote_connected) &&
              <p className="rooms__videoconference-room-empty-message">
                Eres el único participante por ahora. Cuando ingrese otro usuario, se continuará con
                la sesión. Si deseas salir, solo presiona el botón rojo del menú inferior. Si elegiste la cámara incorrecta, puedes cambiarla en la esquina inferior izquierda.
                Recuerda que Terapi no terminará la sesión sin aviso, si la comunicación se cae intenta entrar denuevo.
              </p>
              }

              <div className="rooms__videoconference-room-options-container">
                  <a href="#" onClick={ this.muteMicrophone } className="option-btn mute-container">
                    <i className={`mute fa ${this.state.audio_muted ? 'fa-microphone-slash' : 'fa-microphone'}`} />
                  </a>
                  <a href="#" onClick={ this.hangup } className="option-btn hang-up-container">
                    <img src={HangUpIcon} alt="Hang Up" onClick={this.hangup} className="hang-up" />
                  </a>
                  {
                    this.isAbleToShareScreen() && 
                    <a href="#" title={!this.state.sharing_screen ? 'Compartir pantalla' : 'Dejar de compartir pantalla'} onClick={ this.shareScreen } className="option-btn share-screen-container">
                      <i className={`fas fa-desktop ${!this.state.sharing_screen ? 'share-screen-icon' : 'share-screen-icon-off'}`} />
                    </a>
                  }
                  <a href="#" onClick={ this.showHelp } className="help-container">
                    ¿Tienes problemas técnicos?
                  </a>
                  {
                    (!window.location.host.includes('mobile')) &&
                    <a href="#" onClick={ this.changeCamera } className="change-camera-container">
                    Cambiar Cámara
                    </a> 
                  }
                  <a href="#" onClick={ this.toggleChat } className="d-sm-none d-md-block rooms__videoconference-chat-btn badge-div-mobile">
                    <i className={`chat-message fa fa-comments`} />
                    { (this.props.holder.notifications === "true") && 
                    <span id="chat-badge" className="indicator-mobile-vc text-warning">
                      <span className="badge badge-notification-vc mobile">!</span>
                    </span>
                    }
                    { (this.props.holder.notifications === "false") && 
                    <span id="chat-badge" className="indicator-mobile-vc text-warning d-none">
                      <span className="badge badge-notification-vc mobile">!</span>
                    </span>
                    }
                  </a>
              </div>

            </div>
          </div>
        </div>
    );
  }
}

VideoConference.propTypes = {
  appointment: PropTypes.shape({
    patient: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    }).isRequired,
    professional: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    }).isRequired,
    start_time: PropTypes.string.isRequired,
  }).isRequired,
  holder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
  }).isRequired,
  roomToken: PropTypes.string.isRequired,
  holderToken: PropTypes.string.isRequired,
  onHangUp: PropTypes.func.isRequired,
};

export default VideoConference;
